<template>
  <div id="app">
    <Nav :class="{'is_index':isIndex}"></Nav>
    <router-view />
    <GoTop></GoTop>
    <Footer></Footer>
  </div>
</template>

<script>
import Nav from './components/nav/Nav'
import Footer from './components/footer/Footer'
import GoTop from './components/goTop/goTop'
export default {
  name: 'App',
  data() {
    return {
      isIndex: false,
    }
  },
  components: {
    Nav,
    Footer,
    GoTop,
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    },
  },
  beforeCreate() {
  },
  created() {
    if (this._isMobile()) {
      // alert("手机端");
      // this.$router.replace('/project_mobile/inlay');
      window.location = '/mobile/'
    } else {
      // alert("pc端");
      // this.$router.replace('/');
    }
    // 路由切换的时候保证页面在顶部
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0)
    })
  },
}
</script>

<style>
#app {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue